import React from 'react'
import { Routes, Route, Link } from 'react-router-dom';
import nlogo2 from '../../Assets/images/nlogo.jpeg'
import logo from '../../Assets/images/logo.png'

const Navtop = () => {
  return (
    <div>
        <header className="headertop">
            <img src={nlogo2} height="65" style={{border:"2px solid white"}} alt="" />   
            
            <img src="" alt="" />  
            <img src={logo} width='100' alt="" /> 
            
        </header>
    </div>
  )
}

export default Navtop
